import LocalizedStrings from 'react-localization';
import es from "./es.json";
const lang = {
    es:"Español",
    // en:"English",
}

const index = new LocalizedStrings({
    es:{...lang,...es},
    // en:{...lang,...en},
});

export default index;
